export const getDateFromId = (id: string) => {
  return new Date(parseInt(id.substring(0, 13)));
};
